export default "__VITE_ASSET__CtYkjtDY__"